import { Button, HorizontalContainer } from '@american-autonomy/ag-ui';

import useTranslation from './hooks/useTranslation';

import {
    ADD_POINT_BUTTON_TEST_ID,
    COMPLETE_BUTTON_TEST_ID,
    REDO_BUTTON_TEST_ID,
    TEST_ID,
    UNDO_BUTTON_TEST_ID
} from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const DrawControls = ({
    onClickAddPoint,
    onClickCompleteDrawing,
    onClickRedo,
    onClickUndo,
    testId = TEST_ID
}: Props) => {
    const { SAVE } = useTranslation();

    return (
        <HorizontalContainer className={styles.horizontalContainer} testId={testId}>
            <Button className={styles.button} onClick={onClickUndo} testId={UNDO_BUTTON_TEST_ID}>
                <div className={styles.undoButtonText}> ↺ </div>
            </Button>

            <Button className={styles.button} onClick={onClickRedo} testId={REDO_BUTTON_TEST_ID}>
                <div className={styles.redoButtonText}> ↺ </div>
            </Button>

            <Button
                className={`${styles.button} ${styles.completeButton}`}
                onClick={onClickCompleteDrawing}
                testId={COMPLETE_BUTTON_TEST_ID}
                text={SAVE}
            />

            {onClickAddPoint && (
                <Button
                    className={styles.button}
                    onClick={onClickAddPoint}
                    testId={ADD_POINT_BUTTON_TEST_ID}
                    text={'+'}
                />
            )}
        </HorizontalContainer>
    );
};

export default DrawControls;
